import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import { observable, computed, action } from 'mobx';
var Question = (_class = /*#__PURE__*/function (_Model) {
  function Question() {
    var _this;
    _classCallCheck(this, Question);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Question, [].concat(args));
    _initializerDefineProperty(_this, "jobId", _descriptor, _this);
    _initializerDefineProperty(_this, "id", _descriptor2, _this);
    _initializerDefineProperty(_this, "attrs", _descriptor3, _this);
    _initializerDefineProperty(_this, "description", _descriptor4, _this);
    _initializerDefineProperty(_this, "type", _descriptor5, _this);
    _initializerDefineProperty(_this, "multi", _descriptor6, _this);
    _initializerDefineProperty(_this, "format", _descriptor7, _this);
    _initializerDefineProperty(_this, "options", _descriptor8, _this);
    // TODO: Keeping casing so that it remains backwards compatible with work-api
    // responses. It should be safe to camelCase once this is the only path of execution.
    _initializerDefineProperty(_this, "collect_time", _descriptor9, _this);
    _initializerDefineProperty(_this, "disallow_future", _descriptor10, _this);
    _initializerDefineProperty(_this, "disallow_past", _descriptor11, _this);
    _initializerDefineProperty(_this, "answer", _descriptor12, _this);
    return _this;
  }
  _inherits(Question, _Model);
  return _createClass(Question, [{
    key: "isAnswered",
    get: function get() {
      var isEmpty = this.answer === undefined || this.answer === null || this.answer === '';
      if (isEmpty) {
        return false;
      }
      if (Array.isArray(this.answer)) {
        return this.answer.length > 0;
      }
      return true;
    }
  }, {
    key: "isBreaker",
    get: function get() {
      return this.type === 'BREAKER';
    }
  }, {
    key: "isDocument",
    get: function get() {
      return this.type === 'DOCUMENTS';
    }
  }, {
    key: "isBool",
    get: function get() {
      return this.type === 'BOOL';
    }
  }, {
    key: "clear",
    value: function clear() {
      this.answer = undefined;
    }
  }, {
    key: "setAnswer",
    value: function setAnswer(answer) {
      this.answer = answer;
    }

    /**
     * Parses the DTO to model properties.
     */
  }, {
    key: "parse",
    value: function parse(attrs) {
      return {
        jobId: attrs.jobId,
        id: attrs.id,
        question: attrs.question,
        description: attrs.description,
        type: attrs.type,
        multi: attrs.multi,
        format: attrs.format,
        options: attrs.options,
        collect_time: attrs.collect_time,
        disallow_future: attrs.disallow_future,
        disallow_past: attrs.disallow_past,
        answer: attrs.answer
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "jobId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "attrs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "description", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "type", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "multi", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "format", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "options", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "collect_time", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "disallow_future", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "disallow_past", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "answer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isAnswered", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAnswered"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isBreaker", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBreaker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDocument", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDocument"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isBool", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBool"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAnswer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAnswer"), _class.prototype), _class);
export { Question as default };
//# sourceMappingURL=Question.js.map
